var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('page-main',{attrs:{"tableData":_vm.tableData,"tablePage":_vm.page,"loading":_vm.loading},on:{"reload":_vm.reload}},[_c('page-header',{ref:"header",attrs:{"slot":"header"},on:{"query":_vm.getData,"reset":_vm.resetPage},slot:"header"}),_c('pagination',{attrs:{"slot":"pager","size":"mini","align":"right","layouts":[
          'Total',
          'Sizes',
          'PrevJump',
          'PrevPage',
          'NextPage',
          'NextJump',
          'FullJump' ],"current-page":_vm.page.curPage,"page-size":_vm.page.pageSize,"page-total":_vm.page.pageTotal},on:{"change":_vm.handlePaginationChange},slot:"pager"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }